// extracted by mini-css-extract-plugin
export default {"skeleton":"TitleLoading_skeleton__k0e2m"};